export default __webpack_public_path__ + "static/media/val.43741deb.jpeg";